/** Floor-plan configuration enums shared by the legacy purchase flow and PF v2. Values are persisted, keep them stable. */

/** 2D vs 3D render mode. */
export enum FloorPlanRenderType {
  RENDER_3D = 'RENDER_3D',
  RENDER_2D = 'RENDER_2D',
}

/** 2D output page orientation. */
export enum FloorPlanFileOrientation {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

/** Editing-flow vs basic (real-estate) product family. */
export enum FloorPlanProductType {
  PRODUCT_EDITING = 'EDITING',
  PRODUCT_BASIC = 'BASIC',
}

/** Template-selection mode (pick a saved template vs create from scratch). */
export enum FloorPlanSelectionType {
  TEMPLATE = 'TEMPLATE',
  CUSTOM = 'CUSTOM',
}

/** 2D color themes. */
export enum FloorPlanColors {
  BLACK = 'BLACK',
  BLUE = 'BLUE',
  GREEN = 'GREEN',
  NEUTRAL = 'NEUTRAL',
}

/** 3D styles. */
export enum Styles {
  STYLE_1 = 'STYLE_1',
  STYLE_2 = 'STYLE_2',
  STYLE_3 = 'STYLE_3',
}

/** 3D camera orientations. */
export enum Orientations {
  BIRD_VIEW = 'BIRD_VIEW',
  ANGLE_VIEW = 'ANGLE_VIEW',
}

/** Output file formats. Values equal their string representations (JPG/PDF). */
export enum FloorPlanFormat {
  JPG = 'JPG',
  PDF = 'PDF',
}

/** Per-editing-product settings (persisted under `floorPlanProductConfig`). */
export interface FloorPlanProductSettings {
  /** Whether the entire uploaded plan file should be used or only a section of it. */
  drawOnlySpecificUnit: boolean | undefined
  /** Required unit specification when drawing a specific unit; optional notes (e.g. legend info) for the entire plan */
  drawOnlySpecificUnitComment: string
}
